import React from "react";
import {useSelector} from "react-redux";
import {Button, TableCell, TableRow, Typography} from "@material-ui/core";
import {dateUtils} from "../utils";
import {isDebug, joinAsFullName} from "../utils/commonUtils";
import {RootState} from "../reducers";
import {
    AccountType,
    ClientAI as CurrentActionsItems,
    ClientAI,
    GIFTOR_PORTAL,
    GWTVersionEnum,
    isServicingAccessible,
} from "../constants";
import * as CActions from "../actions/client";
import { useActions } from "../actions";
import {isAdmin} from "./navigation/AdminNavigation";

type ClientActionItemListRowProps = {
    actionItem: any,
    history: any,
    getActionName: Function;
    onViewProposal: Function;
    refreshList?: Function;
    setRequestDocuments?: Function;
    viewDocumentChange?: Function;
    handleRequestModification: Function;
    setCallingFromParent: Function;
}


const ClientActionItemListRow = (props: ClientActionItemListRowProps) => {
    const {actionItem, getActionName, history, onViewProposal, refreshList, setRequestDocuments, viewDocumentChange, handleRequestModification, setCallingFromParent} = props;
    const {user} = useSelector((state: RootState) => state.auth);
    const gen2UserEnrollment = actionItem.enrollment;
    const {role}: any = user;
    const servicingClient = isServicingAccessible(user);
    const gen2User = gen2UserEnrollment && gen2UserEnrollment.user;
    const isGWTEnrollment = gen2User && gen2User.client && gen2User.client.gwtVersion === GWTVersionEnum.Two;
    const gen2UserClient = gen2User && gen2User.client;
    const gen2UserClientPolicy = gen2UserClient && gen2UserClient.clientPolicies && gen2UserClient.clientPolicies.length > 0 && gen2UserClient.clientPolicies[0];
    const isDisabled = actionItem.status === 1 || (ClientAI[actionItem.actionType].restrictedRoles && ClientAI[actionItem.actionType].restrictedRoles.includes(role));
    const { completeActionItem } = useActions(CActions);
    const commonButtonProps: any = {
        className: "btnSmall",
        color: "primary",
        size: "small",
        type: "button",
        variant: "outlined",
    };

    if (isDebug()) {
        console.info(actionItem, "actionItem");
    }

    const onButtonClick = async (actionType: string) => {
        // clientPolicyId of gen1User
        // enrollmentId of gen2user

        switch (actionType) {
            case ClientAI.PARENT_REVIEW_APPROVE.actionType:
                return onViewProposal(actionItem.id, actionItem.enrollmentId, actionItem.status, gen2UserClientPolicy.id, gen2UserClientPolicy.paymentFrequency, gen2UserClient.gwtVersion);
            case ClientAI.MAKE_PAYMENT.actionType:
                history.push(`/giftor/recipient/detail/${gen2UserClient.id}/${gen2UserClientPolicy.id}/managePayments`);
                break;
            case ClientAI.PAYMENT_REJECTED.actionType:
                if([AccountType.Admin, AccountType.MasterAdmin].includes(role as number)) {
                    await completeActionItem({ clientPolicyId: actionItem.clientPolicyId, actionType: actionType  });
                    typeof refreshList == "function" && refreshList()
                    return
                }else if(isGWTEnrollment){
                    history.push(`/giftor/recipient/detail/${gen2UserClient.id}/${gen2UserClientPolicy.id}/managePayments`);
                }else {
                    history.push("/client/payments");
                }
                break;
            case ClientAI.REQUEST_CHANGES.actionType:
                console.log("actionItem", actionType);
                if (typeof setRequestDocuments == 'function' ) { setRequestDocuments(true) }
                if (typeof viewDocumentChange == 'function' ) { return viewDocumentChange(actionItem.enrollmentId, gen2UserClientPolicy.id); }
                break
            case ClientAI.ID_DOC_EXPIRED.actionType:
                history.push("/client/plandocuments?tab=1")
                break;
            case ClientAI.DOCUMENT_REJECTED.actionType:
                // may need to check if servicin enable might be case
                history.push("/client/plandocuments?tab=1")
                break
            default:
                history.push("/client/insured-details");
                break;
        }
    };

    return (
            <TableRow hover key={actionItem.id}>
                <TableCell style={{whiteSpace: "break-spaces"}}>
                    <Typography variant={"body2"}>
                        {joinAsFullName(gen2User)}
                    </Typography>
                </TableCell>
                <TableCell>
                    {
                        getActionName(actionItem)
                    }
                </TableCell>
                {
                    (isAdmin(user) || servicingClient) &&
                    <TableCell style={{whiteSpace: "break-spaces"}}>
                        <Typography variant={"body2"}>
                            {actionItem.rejectionMessage}
                        </Typography>
                    </TableCell>
                }
                <TableCell>
                    {
                        dateUtils.asDbDateFormat(actionItem.status === 0 ? actionItem.createdAt : actionItem.updatedAt)
                    }
                </TableCell>
                <TableCell>
                    {CurrentActionsItems[actionItem.actionType].actionButton && <Button
                            {...commonButtonProps}
                            disabled={isDisabled}
                            variant="contained"
                            onClick={()=> onButtonClick(actionItem.actionType)}
                    >
                        {CurrentActionsItems[actionItem.actionType].actionButton}
                    </Button>}
                    {
                        actionItem.actionType === ClientAI.PARENT_REVIEW_APPROVE.actionType &&
                        <Button
                            {...commonButtonProps}
                            className="ml5"
                            disabled={isDisabled}
                            onClick={() => {
                                handleRequestModification(actionItem.enrollmentId);
                                setCallingFromParent(true);
                            }}
                            >
                            {'Request Modification'}
                        </Button>
                    }
                </TableCell>
            </TableRow>
    );
};

export default ClientActionItemListRow;